<template>
  <div class="body_right">
    <div class="body_right_first">
      <div class="img"><img src="@/assets/imgs/icon_open.png"></div>
      <div class="title">チャット</div>
    </div>
    <div class="body_right_second">
      <div class="body_right_second_top">
        <div class="body_right_second_left">
        </div>
      </div>
      <div class="body_right_second_content">
        <div class="body_right_second_content_left">
          <div class="item" v-for="(item,index) in list" v-bind:class="{click:on_click_id==item.id}" @click="on_click_id = item.id">
            <div class="item_delete" @click="deleteUserList(item.id)"><img src="@/assets/imgs/chat_delete.png" /></div>
            <div class="item_user_img"><img :src="item.avatar" /></div>
            <div class="item_user_name">{{item.nickname}}</div>
            <div class="item_user_sign">{{item.sign}}</div>
            <div class="item_user_notice" v-if="getNotice(item.id)!=0">{{getNotice(item.id)}}</div>
          </div>
        </div>
        <div class="body_right_second_content_right">
          <div class="chat_msg" ref="mianscroll" :key="on_click_id">
            <div class="chat_msg_message" v-for="(item,index) in historyChat" :key="index">
              <div class="chat_msg_others" v-if="item.from == $store.state.userInfo.id">
                <div class="chat_msg_others_img"><img :src="on_click_img"/></div>
                <div class="chat_msg_others_content">{{item.content}}</div>
                <div class="chat_msg_others_time">{{getTime(item.createdDate)}}</div>
              </div>
              <div class="chat_msg_own" v-if="item.from == on_click_id">
                <div class="chat_msg_own_img"><img :src="$store.state.userInfo.avatar"></div>
                <div class="chat_msg_own_content">{{item.content}}</div>
                <div class="chat_msg_own_time">{{getTime(item.createdDate)}}</div>
              </div>
            </div>
          </div>
          <div class="chat_input">
            <textarea v-model="inputContent"></textarea>
          </div>
          <div class="chat_send" @click="chatSendFun" v-if="$store.state.userInfo.id!=on_click_id">送信</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import historyItem from '@/components/historyItem/index'
import { isEmptyObject, getNow, getTime } from '@/assets/js/util'
import deepCopy from 'json-deep-copy'
  export default {
    components: {
      historyItem
    },
    data () {
      return {
        list: [],
        on_click_id: 0,
        on_click_img: '',
        othersList: [],
        ownList: [],
        historyChat: [],
        inputContent: null
      }
    },
    created () {
      this.fetch()
    },
    watch:{
      "$store.state.chatList":{
        handler:function(newval,oldval){
          this.fetchs()
        }
      },
      "$store.state.msgList":{
        handler:function(newval,oldval){
          this.fetchs()
        }
      },
      "on_click_id":{
        handler:function(newval,oldval){
          this.fetchs()
        }
      }
    },
    methods: {
      fetch(){
        if(this.$store.state.chatList){
          this.list = this.$store.state.chatList[this.$store.state.userInfo.id]
        }
        this.on_click_id = this.list&&this.list.length!=0?this.list[0].id:0
        this.getUserimg(this.on_click_id)
        this.othersList = []
        this.ownList = []
        if(this.$store.state.msgList){
          this.othersList = this.$store.state.msgList[this.on_click_id]
          this.ownList = this.$store.state.msgList[this.$store.state.userInfo.id]
        }
        const historyChat = []
        const msgList = this.$store.state.msgList
        if(this.othersList!=[] && this.ownList!=[]&&this.othersList&&this.ownList){
          this.othersList.forEach((item,index) =>{
            if(item.ownerId == this.on_click_id){
              historyChat.push(item)
              if(item.read == undefined){
                item.read = 1
                if(msgList.length!=0){
                  msgList[this.on_click_id].splice(index, 1)
                  msgList[this.on_click_id].splice(index,0,item)
                }
              }
            }
          })
        }
        this.$store.commit('SET_UNREAD_MSG_LIST', msgList)
        if(this.ownList!==undefined && this.ownList){
          this.ownList.forEach(item =>{
            if(item.from == this.on_click_id){
              historyChat.push(item)
            }
          })
        }
        this.historyChat = historyChat.sort(function(a,b){
          let value1 = a['createdDate'];
          let value2 = b['createdDate'];
          return value1 - value2;
        })
        this.$nextTick(() =>{
          this.scrs()
        })
      },
      fetchs(){
        const historyChat = []
        this.getUserimg(this.on_click_id)
        if(!this.$store.state.msgList){
          this.othersList = []
          this.ownList = []
          return
        }else{
          this.othersList = this.$store.state.msgList[this.on_click_id]
          this.ownList = this.$store.state.msgList[this.$store.state.userInfo.id]
        }
        const msgList = this.$store.state.msgList
        if(this.othersList!=[] && this.ownList!=[]&&this.othersList&&this.ownList){
          this.othersList.forEach((item,index) =>{
            if(item.ownerId == this.on_click_id){
              historyChat.push(item)
              if(item.read == undefined){
                item.read = 1
                if(msgList.length!=0){
                  msgList[this.on_click_id].splice(index, 1)
                  msgList[this.on_click_id].splice(index,0,item)
                }
              }
            }
          })
        }
        this.$store.commit('SET_UNREAD_MSG_LIST', msgList)
        if(this.ownList!==undefined && this.ownList){
          this.ownList.forEach(item =>{
            if(item.from == this.on_click_id){
              historyChat.push(item)
            }
          })
        }
        this.historyChat = historyChat.sort(function(a,b){
          let value1 = a['createdDate'];
          let value2 = b['createdDate'];
          return value1 - value2;
        })
        this.$nextTick(() =>{
          this.scrs()
        })
        
      },
      getNotice(id){
        let notice = 0
        let othersList = []
        if(this.$store.state.msgList){
          othersList = this.$store.state.msgList[id]
        }
        if(othersList){
          othersList.forEach(item =>{
            if(item.from == this.$store.state.userInfo.id){
              if(item.read == undefined){
                notice ++ 
              }
            }
          })
        }
        return notice
      },
      scrs(){
        let scrollEl = this.$refs.mianscroll;
        scrollEl.scrollTo({ top: scrollEl.scrollHeight, behavior: 'smooth' });
      },
      chatSendFun(){
        if (!this.inputContent) {
          this.$message.error('消息不能为空');
          return false
        }
        const option = {
          'receiverId': this.on_click_id,
          'content': this.inputContent
        }
        let user = this.$store.state.userInfo
        let tuser = {}
        this.list.forEach(item => {
          if(this.on_click_id == item.id){
            tuser = item
          }
        });
        let thas = this
        this.$socket.emit('chatMessage', option, function () {
          const msg = {
            'uid': tuser.id,
            'ownerId': user.id,
            'from': tuser.id,
            'content': option.content,
            'createdDate': getNow()
          }
          const msgList = deepCopy(thas.$store.state.msgList)
          if(!msgList){
            thas.$store.commit('SET_UNREAD_MSG_LIST',[])
            msgList = deepCopy(thas.$store.state.msgList)
          }
          if (!msgList[user.id]) {
            msgList[user.id] = []
          }
          msgList[user.id].push(msg)
          thas.$store.commit('SET_UNREAD_MSG_LIST',msgList)
          setTimeout(() => {
            thas.inputContent = null
          }, 50)
        })

      },
      deleteUserList(id){
        this.historyChat=[]
        this.list.forEach((item,index) =>{
          if(item.id == id){
            this.list.splice(index,1)
          }
        })
        if(this.list.length>0){
          this.on_click_id = this.list[0].id
        }else{
          this.on_click_id = 0
        }
        
      },
      getUserimg(id){
        if(id!=0){
          this.list.forEach(item =>{
            if(id == item.id){
              this.on_click_img = item.avatar
            }
          })
        }
      },
      compare(property){
        return function(a,b){
          let value1 = a[property];
          let value2 = b[property];
          return value1 - value2;
        }
      },
      getTime(time){
        return getTime(time)
      },
    }
  }
</script>

<style src="@/pages/homePage/notice/likeNotice/index.css" scoped>
</style>
<style>
  .body_right_second_top{
    width: 906px;
    height: 56px;
    border-bottom: 2px solid #ebebeb;
  }
  .body_right_second_left{
    width: 268px;
    height: 56px;
    border-right: 2px solid #ebebeb;
  }
  .body_right_second_content{
    border-bottom: 2px solid #EBEBEB;
  }
  .body_right_second_content_left{
    width: 268px;
    height: 847px;
    border-right: 2px solid #ebebeb;
    display: inline-block;
    vertical-align: top;
    overflow-y: auto;
  }
  .body_right_second_content_left::-webkit-scrollbar {
    width: 9px;
    background: #EBEBEB;
    border-radius: 5px;
  }
  .body_right_second_content_left .item{
    width: 268px;
    height: 68px;
    cursor: pointer;
    position: relative;
  }
  .body_right_second_content_left .item .item_delete{
    display: none;
  }
  .body_right_second_content_left .click{
    background: #EFF5F7;
  }
  .body_right_second_content_left .click .item_delete{
    display: inline-block;
    position: absolute;
    top: 29px;
    left: 14px;
  }
  .item_delete img{
    width: 11px;
    height: 11px;
  }
  .item_user_img{
    width: 47px;
    height: 47px;
    position: absolute;
    top: 10px;
    left: 55px;
  }
  .item_user_img img{
    width: 47px;
    height: 47px;
    border-radius: 50%;
  }
  .item_user_name{
    font-size: 16px;
    font-weight: 400;
    color: #3399CC;
    line-height: 16px;
    position: absolute;
    top: 15px;
    left: 128px;
  }
  .item_user_sign{
    width: 130px;
    font-size: 16px;
    font-weight: 400;
    color: #999999;
    line-height: 16px;
    position: absolute;
    top: 34px;
    left: 127px;
    overflow: hidden;
  }
  .item_user_notice{
    width: 17px;
    height: 17px;
    background: #FF3300;
    border: 1px solid #FFFFFF;
    border-radius: 50%;
    font-size: 9px;
    font-weight: 400;
    color: rgba(255, 255, 255, 0.9);
    line-height: 17px;
    text-align: center;
    position: absolute;
    top: 24px;
    right: 32px;
  }
  .body_right_second_content_right{
    width: 636px;
    height: 847px;
    display: inline-block;
    position: relative;
    vertical-align: top;
  }
  .chat_input{
    width: 636px;
    height: 227px;
  }
  .chat_input  textarea{
    width: 586px;
    height: 176px;
    resize:none;
    font-size: 16px;
    font-weight: 300;
    color: #333333;
    line-height: 24px;
    outline: none;
    border: 0;
    padding: 25px 22px;
    font-size: 16px;
    font-weight: 400;
    color: #333333;
    line-height: 24px;
  }
  .chat_send{
    cursor: pointer;
    width: 56px;
    height: 28px;
    background: #FFFFFF;
    border: 1px solid #DDDDDD;
    border-radius: 4px;
    text-align: center;
    line-height: 28px;
    font-size: 16px;
    font-weight: 400;
    color: #666666;
    position: absolute;
    bottom: 14px;
    right: 29px;
  }
  .chat_msg{
    width: 100%;
    height: 598px; 
    overflow-y: auto;
    padding-top: 20px;
    border-bottom: 2px solid #EBEBEB;
  }
  .chat_msg::-webkit-scrollbar {
    width: 9px;
    background: #EBEBEB;
    border-radius: 5px;
  }
  .chat_msg_others,.chat_msg_own{
    width: 100%;
    position: relative;
  }
  .chat_msg_others_img{
    position: absolute;
    top: -2px;
    left: 13px;
    font-size: 0;
    line-height: 34px;
  }
  .chat_msg_own_img{
    position: absolute;
    bottom: 37px;
    right: 31px;
    font-size: 0;
    line-height: 34px;
  }
  .chat_msg_others_img img,.chat_msg_own_img img{
    width: 34px;
    height: 34px;
    border-radius: 50%;
  }
  .chat_msg_others_content{
    max-width: 256px;
    display: inline-block;
    padding: 19px 14px 26px 14px;
    margin-left: 57px;
    margin-bottom: 37px;
    background: #F6F6F6;
    border: 1px solid rgba(204, 204, 204, 0.3);
    border-radius: 0px 6px 6px 6px;
    font-size: 16px;
    font-weight: 300;
    color: #333333;
    line-height: 24px;
  }
  .chat_msg_own{
    text-align: right;
  }
  .chat_msg_own_content{
    max-width: 256px;
    display: inline-block;
    margin-right: 73px;
    padding: 19px 14px 26px 14px;
    margin-bottom: 37px;
    background: #F6F6F6;
    border: 1px solid rgba(204, 204, 204, 0.3);
    border-radius: 6px 6px 0px 6px;
    font-size: 16px;
    font-weight: 300;
    color: #333333;
    line-height: 24px;
  }
  .chat_msg_others_time{
    font-size: 12px;
    line-height: 12px;
    position: absolute;
    left: 70px;
    bottom: 20px;
    color: #888;
  }
  .chat_msg_own_time{
    font-size: 12px;
    line-height: 12px;
    position: absolute;
    right: 86px;
    bottom: 20px;
    color: #888;
  }
</style>

